import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {SpineUtils} from "../../utils/SpineUtils";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

/**
 * Created by Jerker Nord on 2023-01-19.
 */

export class BenjiKIVNoWinView extends PIXI.Container implements StageLayer {

    private static ANIMATION_NAMES:string[] = ["No_Win_1", "No_Win_2", "No_Win_3"];

    private _noWinAnimation:PIXI.spine.Spine;
    private _background:PIXI.Sprite;
    private _randomInt:number;
    private _noWinTL:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "BenjiKIVNoWinView";

        this.init();
    }

    private init():void {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._noWinAnimation = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.NO_WIN_SPINE));
        this._noWinAnimation.position.set(360, 360);
        this._noWinAnimation.visible = false;
        this.addChild(this._noWinAnimation);

        this.onResize();
    }

    public getNoWinTL():gsap.core.Timeline {
        this._noWinTL = gsap.timeline();
        this._randomInt = MathHelper.randomIntInRange(0, (BenjiKIVNoWinView.ANIMATION_NAMES.length - 1));
        this._noWinTL.add(() => {
            this._background.alpha = 0;
            this._background.visible = true;
            gsap.to(this._background, {duration : 0.4, alpha : 0.7});
            this._noWinAnimation.visible = true;
            SpineUtils.resetSpineAnimation(this._noWinAnimation);
        }, "+=0.3");
        this._noWinTL.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.NO_WIN_SOUNDS[this._randomInt])});
        this._noWinTL.add(new SpineTween(this._noWinAnimation, 0, BenjiKIVNoWinView.ANIMATION_NAMES[this._randomInt]));

        this._noWinTL.add(() => {
            this._noWinAnimation.visible = false;
            BenjiKIV.soundPlayer.stopSound(BenjiKIVSound.NO_WIN_SOUNDS[this._randomInt]);
            this._background.alpha = 0.7;
            gsap.to(this._background, {duration : 0.2, alpha : 0});
        });
        this._noWinTL.add(gsap.timeline({delay : 0.2}).add(() => {this._background.visible = false}));
        return this._noWinTL;
    }

    public onResize():void {
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;
    }
}